import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { YodaColors, YodaFontSize, YodaBorderRadius, YodaSpacing, YodaFontWeight } from 'yoda-ui/yodaTheme'; // Add YodaFontWeight

export const filtersSectionStyle: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: YodaColors.white,
  padding: YodaSpacing.medium,
  boxShadow: `0px 5px 20px ${YodaColors.gray2}`,
  borderRadius: YodaBorderRadius.medium,
  border: 'none',
  overflow: 'visible',
};

export const filtersHeaderStyle: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: YodaSpacing.medium,
};

export const filtersTitleStyle: SxProps<Theme> = {
  fontWeight: YodaFontWeight.bold,
  fontSize: YodaFontSize.xLarge,
};

export const filtersResultsStyle: SxProps<Theme> = {
  fontSize: YodaFontSize.medium,
  fontWeight: YodaFontWeight.regular,
};

export const filtersResultsValueStyle: SxProps<Theme> = {
  fontWeight: YodaFontWeight.bold,
};

export const filtersFormStyle: SxProps<Theme> = (theme) => ({
  display: 'grid',
  width: '100%',
  gap: YodaSpacing.small,
  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(12, 1fr)',
  },

  '& > div': {
    width: '100% !important',
    marginBottom: '0 !important',

    [theme.breakpoints.up('md')]: {
      '&:nth-of-type(1)': {
        gridColumn: 'span 4',
      },
    },
  },
});

export const selectedTagsStyle: SxProps<Theme> = {
  marginTop: YodaSpacing.small,
  display: 'flex',
  rowGap: YodaSpacing.small,
  columnGap: YodaSpacing.xxSmall,
  flexWrap: 'wrap',
};

export const resetButtonStyle: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  cursor: 'pointer',
  color: YodaColors.blue7,
  fontWeight: 500,
  fontSize: '14px',
  userSelect: 'none',
  transition: 'opacity 0.2s',
  '&:hover': { opacity: 0.8 },
};

export const sortSelectWrapperStyle: SxProps<Theme> = {
  width: 'fit-content !important',
  marginY: YodaSpacing.medium,
  marginLeft: 'auto',
};

export const sortSelectStyle: SxProps<Theme> = {
  height: '48px',
  borderRadius: '48px',
  fontSize: YodaFontSize.medium,
  border: `2px solid ${YodaColors.blue7}`,
  color: YodaColors.blue7,
  transition: '0.3s ease all',
  cursor: 'pointer',

  '& .MuiSelect-select': {
    paddingLeft: '24px !important',
    paddingRight: '48px !important',
  },

  '&:hover': {
    background: YodaColors.blue2,
  },

  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent !important',
  },

  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'transparent !important',
    borderWidth: '0px !important',
  },

  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },

  '& .MuiSelect-icon': {
    color: `${YodaColors.blue7} !important`,
    transition: '0.3s ease all',
    right: '24px',
  },
};
